export default __webpack_public_path__ + "static/og_image_community-075cb45bb17add39e3b514fe599ce22a.webp";